<template>
    <div class="doc-edit">

        <support-plan v-if="docTool == 'supportPlan'">
        </support-plan>

        <behavior-report v-if="docTool == 'behaviorReport'">
        </behavior-report>

        <progress-monitor v-if="docTool == 'progressMonitor'">
        </progress-monitor>

        <chart-dog v-if="docTool == 'chartDog'">
        </chart-dog>

        <checklist-maker v-if="docTool == 'checklistMaker'">
        </checklist-maker>

        <list-generator v-if="docTool == 'listGenerator'">
        </list-generator>

        <div class="mt-5" v-if="docNotFound">
            <h1>Document not Found</h1>
            <p>
                This document has been deleted.
            </p>
            <router-link to="/">Return to Home Page</router-link>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'

    export default Vue.extend({
        name: 'DocEdit',
        props: {
            docId: String
        },
        computed: {
            docTool() {
                return this.$store.state.doc ? this.$store.state.doc.tool : null
            },
            docNotFound() {
                return this.$store.state.docNotFound
            }
        },
        mounted() {
            // NB: loadDoc will fail when loading an edit page directly via URL - see Api.ensureDocLoaded()
            this.$store.dispatch('loadDoc', {docId: this.docId})
        },
    })
</script>
